<template>
  <div @click="handleShare" class="share-button-as-slot">
    <slot name="trigger"></slot>
  </div>
</template>

<script>
  import shortLinkApi from '@/api/v3/shortLink'
  import { Toast } from 'vant'

  export default {
    name: 'ShareButton',
    props: {
      path:       { type: String, required: true },
      query:      { type: String, default: '' },
      linkType:   { type: String, default: '' },
      nfcChipId:  { type: String, default: '' },
      username:   { type: String, default: '好友' },  // 分享人名称
      title:      { type: String, default: '分享内容' },  // 分享标题
      content:    { type: String, default: '这是一个很棒的分享内容' },  // 分享内容
      logo:       { type: String, default: 'https://eforall.cn/logo.png' }  // 分享Logo
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
      async handleShare() {
        if (this.loading) return
        this.loading = true
        
        try {
          const response = await shortLinkApi.createOrGetShortLink({
            path: this.path, 
            linkType: this.linkType,
            nfcChipId: this.nfcChipId, 
            query: this.query,
            title: this.title,
            content: this.content,
            logo: this.logo
          })
          
          const shortCode = response.code
          
          // 跳转到分享预览页面，传递必要的参数
          this.$router.push({
            path: `/s/${shortCode}`,
            query: {
              preview: '1',  // 标识这是预览模式
              title: response.title || this.title,
              content: response.content || this.content,
              logo: response.logo || this.logo,
              originalUrl: response.originalUrl,
              shortUrl: response.shortUrl,
              qrCode: response.qrCode
            }
          })
          
        } catch (err) {
          Toast.fail(`生成分享信息失败：${err.message}`)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .share-button-as-slot {
    width: 100%;
    height: 100%;
    display: flex; /* 让内容居中 */
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShareButton/index.vue